var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 708,
    height: 708,
    viewBox: "0 0 708 708",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 354,
    r: 354,
    fill: "#31BDDC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 256.614,
    y: 98,
    width: 26.7882,
    height: 512.5,
    rx: 13.3941,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 424.393,
    y: 98,
    width: 26.7882,
    height: 512.5,
    rx: 13.3941,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 284.108,
    width: 26.7882,
    height: 512.5,
    rx: 13.3941,
    transform: "rotate(-90 98 284.108)",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 451.886,
    width: 26.7882,
    height: 512.5,
    rx: 13.3941,
    transform: "rotate(-90 98 451.886)",
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 329.136,
    y: 288.337,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 372.292,
    y: 288.337,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 288.337,
    y: 336.208,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    transform: "rotate(-90 288.337 336.208)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 288.337,
    y: 379.364,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    transform: "rotate(-90 288.337 379.364)",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 150.078,
    y: 109.279,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 193.235,
    y: 109.279,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 109.279,
    y: 157.15,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    transform: "rotate(-90 109.279 157.15)",
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 109.279,
    y: 200.306,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    transform: "rotate(-90 109.279 200.306)",
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 150.078,
    y: 287.632,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 193.235,
    y: 287.632,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 109.279,
    y: 335.503,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    transform: "rotate(-90 109.279 335.503)",
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 109.279,
    y: 378.659,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    transform: "rotate(-90 109.279 378.659)",
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 150.078,
    y: 465.985,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 193.235,
    y: 465.985,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 109.279,
    y: 513.856,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    transform: "rotate(-90 109.279 513.856)",
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 109.279,
    y: 557.012,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    transform: "rotate(-90 109.279 557.012)",
    fill: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 329.136,
    y: 465.985,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    fill: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 372.292,
    y: 465.985,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    fill: "white"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 288.337,
    y: 513.856,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    transform: "rotate(-90 288.337 513.856)",
    fill: "white"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 288.337,
    y: 557.013,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    transform: "rotate(-90 288.337 557.013)",
    fill: "white"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 502.554,
    y: 465.985,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    fill: "white"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 545.711,
    y: 465.985,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    fill: "white"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 461.755,
    y: 513.856,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    transform: "rotate(-90 461.755 513.856)",
    fill: "white"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 461.755,
    y: 557.012,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    transform: "rotate(-90 461.755 557.012)",
    fill: "white"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 502.554,
    y: 109.984,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    fill: "white"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 545.711,
    y: 109.984,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    fill: "white"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 461.755,
    y: 157.855,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    transform: "rotate(-90 461.755 157.855)",
    fill: "white"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 461.755,
    y: 201.012,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    transform: "rotate(-90 461.755 201.012)",
    fill: "white"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 329.136,
    y: 109.984,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    fill: "white"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 372.292,
    y: 109.984,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    fill: "white"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 288.337,
    y: 157.855,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    transform: "rotate(-90 288.337 157.855)",
    fill: "white"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 288.337,
    y: 201.011,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    transform: "rotate(-90 288.337 201.011)",
    fill: "white"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 502.554,
    y: 288.337,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    fill: "white"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 545.711,
    y: 288.337,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    fill: "white"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 461.755,
    y: 336.208,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    transform: "rotate(-90 461.755 336.208)",
    fill: "white"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 461.755,
    y: 379.364,
    width: 6.8905,
    height: 131.826,
    rx: 3.44525,
    transform: "rotate(-90 461.755 379.364)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.dc796911904bd35786be69e7c4038881.svg";
export { ForwardRef as ReactComponent };